<div class="cta" *transloco="let t; read: 'cta-panel'">
  <h1 class="title">{{ t('cta.title') }}</h1>
  <h2 class="subtitle">{{ t('cta.subtitle') }}</h2>
</div>
<img src="./assets/images/recipient_auth_art.png" alt="" />
